import { defineByokProvider } from '@tanstack/ai/byok'

export const bedrockByok = defineByokProvider({
  id: 'bedrock',
  label: 'Amazon Bedrock',
})
